import React, { useState } from 'react';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { TextField } from 'src/components/new/inputs/TextField';
import { Alert } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface AddOrganizationPromoCodeProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (name: string) => void;
  networkError: string;
}

const AddOrganizationPromoCode: React.FC<AddOrganizationPromoCodeProps> = ({
  open,
  onClose,
  onSuccess,
  networkError,
}) => {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  const handleSubmit = () => {
    if (name === '') {
      setNameError('Promo code is required');
    } else {
      onSuccess(name);
    }
  };

  const handleClose = () => {
    setName('');
    setNameError('');
    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} sx={{ minWidth: '27.5rem' }}>
        <ModalTitle small onClose={handleClose}>
          Add Promo Code
        </ModalTitle>
        <ModalContent small>
          <TextField
            required
            value={name}
            name="promoCode"
            id="promoCode"
            onChange={(e) => setName(e.target.value)}
            error={nameError}
            label="Promo Code"
          />
          {networkError && (
            <Alert
              icon={<InfoIcon sx={{ color: '#5e0a05' }} />}
              color="error"
              sx={{ border: '0.0625rem solid #5e0a05', borderRadius: '0.75rem', fontWeight: 500, width: 'fit-content' }}
            >
              {networkError}
            </Alert>
          )}
        </ModalContent>
        <ModalFooter onSubmit={handleSubmit} submitText="Apply" />
      </Modal>
    </>
  );
};

export default AddOrganizationPromoCode;
